import script from "./BirthRing.vue?vue&type=script&setup=true&lang=js"
export * from "./BirthRing.vue?vue&type=script&setup=true&lang=js"

import "./BirthRing.vue?vue&type=style&index=0&id=84d08176&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-84d08176"]])

export default __exports__